export const REQUEST_ACCESS_TOKEN = 'zola/zoom/REQUEST_ACCESS_TOKEN';
export const RECEIVE_ACCESS_TOKEN = 'zola/zoom/RECEIVE_ACCESS_TOKEN';
export const REMOVE_ACCESS_TOKEN = 'zola/zoom/REMOVE_ACCESS_TOKEN';
export const REQUEST_MEETING = 'zola/zoom/REQUEST_MEETING';
export const RECEIVE_MEETING = 'zola/zoom/RECEIVE_MEETING';
export const REQUEST_CONNECTION_SETTINGS = 'zola/zoom/REQUEST_CONNECTION_SETTINGS';
export const RECEIVE_CONNECTION_SETTINGS = 'zola/zoom/RECEIVE_CONNECTION_SETTINGS';
export const REQUEST_CONNECTION = 'zola/zoom/REQUEST_CONNECTION';
export const RECEIVE_CONNECTION = 'zola/zoom/RECEIVE_CONNECTION';
export const RECEIVE_ZOOM_PLAN_TYPE = 'zola/zoom/RECEIVE_ZOOM_PLAN_TYPE';



// WEBPACK FOOTER //
// ./src/actions/types/ZoomActionTypes.js